<script>
  import ReleaseLabs from '../content/ReleaseLabs.svelte';
</script>

<a id="about" class="anchor flex" href="#about">&nbsp;</a>
<ReleaseLabs />
